import { render, staticRenderFns } from "./ResourceRouteItem.vue?vue&type=template&id=2be764b3&scoped=true"
import script from "./ResourceRouteItem.vue?vue&type=script&lang=js"
export * from "./ResourceRouteItem.vue?vue&type=script&lang=js"
import style0 from "./ResourceRouteItem.vue?vue&type=style&index=0&id=2be764b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be764b3",
  null
  
)

export default component.exports